export default __webpack_public_path__ + "static/media/phone-forwarded.36078efc.svg";